/**
 * Pobranie pliku z `/api/v1` z tą samą sesją co reszta żądań.
 *
 * Zwykły odnośnik `<a href download>` też niósłby ciasteczko, ale błąd
 * walidacji (np. literówka w filtrze) zapisałby się wtedy na dysku jako plik
 * CSV z kopertą JSON w środku. Tu błąd wraca jako `ApiError` i trafia na
 * ekran, a plik powstaje dopiero z poprawnej odpowiedzi.
 */

import { ApiError } from "./api";

export async function downloadFile(path: string): Promise<string> {
  const response = await fetch(`/api/v1${path}`, { credentials: "include" });
  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    const error = (payload as { error?: { message?: string; code?: string } } | null)?.error;
    throw new ApiError(
      error?.message ?? `Błąd ${response.status}`,
      response.status,
      error?.code ?? "unknown",
    );
  }

  const disposition = response.headers.get("Content-Disposition") ?? "";
  const filename = /filename="([^"]+)"/.exec(disposition)?.[1] ?? "folwark-eksport.csv";
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  // Przeglądarka kopiuje blob przy rozpoczęciu pobierania; zwolnienie od razu
  // potrafi je przerwać w Firefoksie, więc z krótkim opóźnieniem.
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
  return filename;
}
